<template>
<div class="home-wrapper"
    :style="{'background-image': 'url(' + require('../assets/img/background@3x.png') + ')'}">
  <div class="home-content">
    <!-- <center> -->
      <div class="homeContainer">
        <div class="firstRow">
          <div class="contentContainer">
            <div class="textContainer">
              <h1 class="text1">THE<br>BLOCKCHAIN SERIES</h1>
              <h1 class="text2">Chronoswiss luxury watches for an everlasting legacy</h1>
              <h1 class="text3">Claim ownership and activate warranty of your Chronoswiss luxury watch registered by LuxTag on the NEM Blockchain.</h1>
              <!-- <h1 class="text2">First Crypto Luxury Watches</h1> -->
              <h1 class="text3">Be the proud owner of the first crypto luxury watches, registered on the NEM Blockchain.</h1>
              <h1 class="text2">Proof of Ownership</h1>
              <h1 class="text3">Through the LuxTag WebApp, customers are able to claim the ownership of the watches using the unique QR code on the warranty card. Furthermore, customers can appreciate the fine details of their very own watches in the assets tab, as well as transfer the ownership to a second buyer.</h1>
              <h1 class="text2">Proof of Origin</h1>
              <h1 class="text3">The LuxTag WebApp enables customers to view the history of the watches, previous owners, and the watches servicing history. Additionally, customers can record notes about the assets for future references. The recorded provenance enhances the value of the watches through generations.</h1>
            </div>
            <div class="buttonsContainer">
              <a class="button" href="https://bit.ly/luxtag-ios" target="_blank">
                <img class="home-logo"  src="../assets/img/apple-store-button@3x.png"/>
              </a>
              <a class="button" href="https://bit.ly/luxtag-android" target="_blank">
                <img class="home-logo"  src="../assets/img/google-play-button@3x.png"/>
              </a>
            </div>
          </div>
          <div class="imageContainer">
            <img class="home-image"  src="../assets/img/btc_series.png"/>
          </div>
        </div>
        <!-- <div class="secondRow">
          <div class="textContainer">
            <h1 class="text1">THE<br>BLOCKCHAIN SERIES</h1>
            <h1 class="text2">Chronoswiss luxury watches for an everlasting legacy</h1>
            <h1 class="text3">Claim ownership and activate warranty of your Chronoswiss luxury watch registered by LuxTag on the NEM Blockchain</h1>
          </div>
        </div> -->
      </div>
    <!-- </center> -->
  </div>
</div>
</template>

<script>
import { EyeIcon } from 'vue-feather-icons';
import iziToast from 'izitoast';

export default {
  name: 'home',
  methods: {
    login() {
      this.$router.push('/login');
    },
  },
  mounted() {
    iziToast.destroy();
  },
  components: {
    EyeIcon,
  },
};
</script>
<!-- You can add "scoped" attribute to limit CSS to this component only -->
<!-- Be carful this can reduce performance -> https://vue-loader.vuejs.org/en/features/scoped-css.html -->
<style lang="scss">
@font-face {
  font-family: "HelveticaNeueLight";
  src: url("../../fonts/helveticaneuelight.woff2") format("woff2");
}

.home-wrapper {
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-align: left;
  height: auto;
  width: 100%;
  background-color: #000;
  background-size: cover;
  // height: 100%;
  /* height: 100%; */
  .home-content {
    //margin: 0 auto;
  }
}

// .header {
//   color: #409EFF;
// }
.h1 {
  font-size: 5.3em;
  margin: 0;
  margin-left: 50px;
}
.eye {
  position: relative;
  display: inline-block;
}
.image {
  position: fixed;
}
.text1 {
  text-align: left;
  font-size: 30px;
  color: #aa9682;
  font-weight: 500;
  margin-left: 50px;
  line-height: 0.92;
  letter-spacing: 0.6px;
  margin-bottom: 0px;
  font-family: "HelveticaNeueLight";
}
.text2 {
  text-align: left;
  font-size: 20px;
  font-weight: 200;
  line-height: 1.23;
  letter-spacing: 0.4px;
  color: #fff;
  margin-left: 50px;
  margin-bottom: 0px;
  font-family: "HelveticaNeueLight";
}
.text3 {
  text-align: left;
  font-size: 16px;
  font-weight: lighter;
  line-height: 1.33;
  letter-spacing: 1.1px;
  color: #8d8d8d;
  margin-left: 50px;
  font-family: "HelveticaNeueLight";
}

.eye::before {
  border-bottom: 9px solid #409EFF;
  width: 120%;
  position: absolute;
  right: -10%;
  top: 50%;
  transform: rotate(-45deg);
}

.homeContainer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  // background: #409EFF;
}
.firstRow {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  // background: #409EFF;
}
.secondRow {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  // background: #409EFF;
}
.contentContainer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: left;
  // background: #d42222;
  width: 50%;
}
.imageContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50%;
  // background: #8138ac;
}
.buttonsContainer {
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: left;
  margin-left: 40px;
  // background: #21e221;
}
.textContainer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: left;
  // background: #ffa9f8;
}

.button {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30%;
  // background-color:rgb(96, 214, 49);
}

.home-image {
  width: 60%;
}

.home-logo{
  width: 100%;
  margin-top: 1%;
  margin-bottom: 1%;
  padding: 1%;
}

// Laptop Big
@media screen and (min-width: 1024px) {
  .button {
    width: 20%;
  }
}

// Tablet and Ipad
@media screen and (max-width: 835px) {
  .firstRow {
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
    justify-content: space-between;
    // background: #409EFF;
  }
  .secondRow {
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
    justify-content: space-between;
    // background: #409EFF;
  }
  .home-image {
    width: 125%;
  }
  .button {
    width: 30%;
  }
  .h1 {
    margin-left: 0px;
  }
  .text1 {
    font-size: 30px;
    margin-left: 0px;
    line-height: 1.08;
    letter-spacing: 0.4px;
    margin-bottom: 0px;
  }
  .text2 {
    font-size: 20px;
    line-height: 1.23;
    letter-spacing: 0.1px;
    margin-left: 0px;
    margin-bottom: 0px;
  }
  .text3 {
    font-size: 16px;
    line-height: 1.08;
    letter-spacing: 0.4px;
    margin-left: 0px;
    margin-top: 5px;
    margin-bottom: 20px;
  }
  .contentContainer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 80%;
    // background: #d42222;
  }
  .buttonsContainer {
    justify-content: center;
    align-items: center;
    margin-left: 0px;
    margin-top: 50px;
    margin-bottom: 50px;
    // background: #21e221;
  }
  .textContainer {
    align-items: left;
    // background: #ffa9f8;
  }
  .home-wrapper {
    // justify-content: flex-start;
    justify-content: center;
  }
}

// Mobile
@media screen and (max-width: 550px) {
  .home-image {
    width: 170%;
  }
  .button {
    width: 50%;
  }
  .buttonsContainer {
    margin-top: 0px;
  }
  .home-wrapper {
    background-size: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// Home.vue?c815eb2c